// extracted by mini-css-extract-plugin
export default {"card":"DisplayNameChangeCard_card__AMVMK","title":"DisplayNameChangeCard_title__L6ZQe","row":"DisplayNameChangeCard_row__Ljw5O"};